'use client';

import React, { useState, useEffect } from 'react';

import IconButton from '@mui/material/IconButton';
import { styled, keyframes } from '@mui/material/styles';

import Iconify from 'src/components/iconify';

const pulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.3);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 12px rgba(25, 118, 210, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
`;

const PulseButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  bottom: 32,
  right: 32,
  width: 38,
  height: 38,
  zIndex: 9999,
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.shadows[3],
  backdropFilter: 'blur(4px)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: 'scale(1.1)',
  },

  '& svg': {
    transition: 'transform 0.3s',
    color: theme.palette.primary.contrastText,
  },

  '&:hover svg': {
    transform: 'translateY(-2px)',
  },

  '&.pulse': {
    animation: `${pulse} 2s infinite ease-out`,
  },
}));

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <PulseButton onClick={scrollToTop} size="medium" className="pulse" aria-label="Scroll to top">
      <Iconify width={28} height={28} icon="solar:double-alt-arrow-up-bold-duotone" />
    </PulseButton>
  );
}
